import React, { useEffect, useState } from 'react';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Chart } from 'common/components/ThemedChart';
import API from 'services/API';
import { colors } from 'UI/res';
import { nestTernary } from 'UI/utils';

/** @typedef {import('types/dashboard').ChartProps} ChartProps */
const columnChartOptions = {
  legend: { position: 'none' },
  chartArea: {
    width: '90%',
    height: '80%'
  },
  vAxis: {
    baselineColor: colors.lightgrey,
    gridlines: {
      color: colors.lightgrey
    },
    textStyle: {
      color: colors.darkGrey
    }
  },
  hAxis: {
    textStyle: {
      color: colors.darkGrey
    }
  }
};

/**
 * @param {ChartProps} props
 */
const ColumnChart = props => {
  const { url, columns } = props;
  const height = 300;
  const [isLoading, setIsLoading] = useState(true);
  const [chartData, setChartData] = useState([]);
  useEffect(() => {
    const loadData = async () => {
      setIsLoading(true);
      try {
        const response = await API.get(url);
        if (response.status === 200 && response.data) {
          setChartData([columns, ...response.data]);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
      setIsLoading(false);
    };
    loadData();
  }, [url, columns]);

  return isLoading ? (
    <Box display="flex" alignItems="center" justifyContent="center" style={{ minHeight: height }}>
      <CircularProgress />
    </Box>
  ) : (
    nestTernary(
      chartData.length > 1,
      <Chart
        width="100%"
        height={`${height}px`}
        chartType="ColumnChart"
        loader={<div>Loading Chart</div>}
        data={chartData}
        options={columnChartOptions}
      />,
      <>There is no data with the selected filters</>
    )
  );
};

export default ColumnChart;
